import OrganizationManagerAddModal from './OrganizationManagerAddModal';

export default OrganizationManagerAddModal;
